import type { PerformanceParameter } from '../types';

export const PERFORMANCE_PARAMETERS: PerformanceParameter[] = [
  {
    name: 'Strength',
    description: 'Raw power and force production capacity',
    icon: 'Dumbbell',
    color: '#EF4444',
    measurementMethod: 'Maximum weight lifted, resistance training performance'
  },
  {
    name: 'Endurance',
    description: 'Sustained physical activity over extended periods',
    icon: 'Zap',
    color: '#F59E0B',
    measurementMethod: 'Cardio duration, distance covered, aerobic capacity'
  },
  {
    name: 'Stamina',
    description: 'Energy reserves and fatigue resistance',
    icon: 'Battery',
    color: '#10B981',
    measurementMethod: 'Work capacity, recovery time, sustained output'
  },
  {
    name: 'Agility',
    description: 'Quick directional changes and coordination',
    icon: 'Sparkles',
    color: '#3B82F6',
    measurementMethod: 'Reaction time, movement speed, coordination drills'
  },
  {
    name: 'Balance',
    description: 'Stability and postural control',
    icon: 'Scale',
    color: '#8B5CF6',
    measurementMethod: 'Single-leg stands, stability exercises, core control'
  },
  {
    name: 'Mobility',
    description: 'Range of motion and flexibility',
    icon: 'Palmtree',
    color: '#EC4899',
    measurementMethod: 'Joint ROM, stretching capacity, movement quality'
  },
  {
    name: 'Power',
    description: 'Explosive force generation',
    icon: 'Zap',
    color: '#F97316',
    measurementMethod: 'Jump height, sprint speed, explosive movements'
  }
];

export const getPerformanceParameterByName = (name: string): PerformanceParameter | undefined => {
  return PERFORMANCE_PARAMETERS.find(param => param.name === name);
};

export const PERFORMANCE_PARAMETER_NAMES = PERFORMANCE_PARAMETERS.map(param => param.name);
